import { UserProps } from '../../constants/Common';
import firebaseApi from '../../firebase/firebaseApi';
import { ContractRates } from './ContractRates';

export const ContractRatesWrapper = ({
	userDetails,
}: UserProps): JSX.Element => (
	<ContractRates firebaseApi={firebaseApi} userDetails={userDetails} />
);
